<template>
  <div v-loading="loading">
    <el-form ref="formRef" :model="formState" :rules="rules">
      <div class="flow-sub-title">借款信息</div>
      <el-row :gutter="16">
        <el-col :span="12" v-if="getIsShow('customerName')">
          <el-form-item label="客户名称">
            <span>{{ info.customerName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('customerPhone')">
          <el-form-item label="客户手机号">
            <span>{{ info.customerPhone }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('idcard')">
          <el-form-item label="身份证号">
            <span>{{ info.idcard }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('drawingAmount')">
          <el-form-item label="申请提款金额">
            <span>{{ info.drawingAmount }}元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('amountLent')">
          <el-form-item label="已放款金额">
            <span>{{ info.amountLent }}元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('productName')">
          <el-form-item label="产品名称">
            <span>{{ info.productName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('productType')">
          <el-form-item label="产品类型">
            <span>{{ productTypeText(info.productType) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('repayNo')">
          <el-form-item label="还款期数">
            <span>第{{ info.repayNo }}期</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flow-sub-title">还款信息</div>
      <el-row :gutter="16">
        <el-col :span="12" v-if="getIsShow('loanDateTime')">
          <el-form-item label="借款日期">
            <span>{{ info.loanDateTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('loanEndTime')">
          <el-form-item label="借款截止日期">
            <span>{{ info.loanEndTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('firstDueDate')">
          <el-form-item label="首次还款日">
            <span>{{ info.firstDueDate }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('yearRate')">
          <el-form-item label="贷款利率">
            <span>{{ info.yearRate }}%</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('loanUse')">
          <el-form-item label="贷款用途">
            <span>{{ info.loanUse }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('repaymentType')">
          <el-form-item label="还款方式">
            <span>{{ repaymentTypeText(info.repaymentType) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('loanDate')">
          <el-form-item label="贷款期限">
            <span>{{ info.loanDate }}月</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('repaymentFrequency')">
          <el-form-item label="还款频率">
            <span>{{ rateListText(info.repaymentFrequency) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('repaymentDate')">
          <el-form-item label="还款日">
            <span>{{ info.repaymentDate }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flow-sub-title">原应收款信息</div>
      <el-row :gutter="16">
        <el-col :span="12" v-if="getIsShow('oldPrincipal')">
          <el-form-item label="应还本金">
            <el-input
              style="width: 100%"
              :value="!isNullOrUndefOrEmpty(info.oldPrincipal) ? info.oldPrincipal : info.principal"
              disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('oldInterest')">
          <el-form-item label="应还利息">
            <el-input
              style="width: 100%"
              :value="!isNullOrUndefOrEmpty(info.oldInterest) ? info.oldInterest : info.interest"
              disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('oldPenaltyInterest')">
          <el-form-item label="应还罚息">
            <el-input
              style="width: 100%"
              :value="
                !isNullOrUndefOrEmpty(info.oldPenaltyInterest)
                  ? info.oldPenaltyInterest
                  : info.penaltyInterest
              "
              disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="getIsShow('oldActualRepaymentDate')">
          <el-form-item label="还款日期">
            <el-date-picker
              style="width: 100%"
              :modelValue="
                !isNullOrUndefOrEmpty(info.oldActualRepaymentDate)
                  ? info.oldActualRepaymentDate
                  : info.repaymentDate
              "
              type="date"
              value-format="YYYY-MM-DD"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flow-sub-title">更新应收款信息</div>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="应还本金" prop="principal">
            <Money
              v-model="formState.principal"
              style="width: 100%"
              :data="{
                unit: '元',
                maxLength: 13,
                precisions: 2,
                setting: JSON.stringify({ web: { uppercase: false } })
              }"
              :renderConfig="{
                disabled: getIsTxt('principal')
              }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应还利息" prop="interest">
            <RxkInput v-model="formState.interest" :disabled="getIsTxt('interest')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应还罚息" prop="penaltyInterest">
            <RxkInput v-model="formState.penaltyInterest" :disabled="getIsTxt('penaltyInterest')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="还款日期" prop="repaymentDate">
            <el-date-picker
              style="width: 100%"
              v-model="formState.repaymentDate"
              type="date"
              value-format="YYYY-MM-DD"
              :disabled="getIsTxt('repaymentDate')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script lang="ts" setup>
import { cloneDeep } from '@/utils/tools'
import { isEmpty, isNullOrUndefOrEmpty } from '@/utils/is'

import Money from '@/components/custom/form/components/money/index.vue'
import { RxkInput } from '@/components/common'
import { getLicensedApproveDetail } from '@/apis/erp/receivablesManage'
import { loanList, repaymentTypes, rateList } from '@/views/erp/enums'

const props = defineProps({
  id: String,
  formValue: {
    type: Object,
    default: () => ({})
  },
  permissions: {
    type: Object,
    default: () => ({})
  },
  tableCode: String,
  allShow: Boolean
})

const loading = ref(true)
const formState = ref<Recordable>({})
const info = ref<any>({})
const formRef = ref()
const rules: Recordable = {
  principal: [{ required: true, message: '请输入应还本金', trigger: 'change' }],
  interest: [{ required: true, message: '请输入应还利息', trigger: 'change' }],
  penaltyInterest: [{ required: true, message: '请输入应还罚息', trigger: 'change' }],
  repaymentDate: [{ required: true, message: '请选择还款日期', trigger: 'change' }]
}

async function getDetails() {
  console.log(props.formValue)
  try {
    loading.value = true
    const res = await getLicensedApproveDetail({ id: props.id })
    info.value = res || props.formValue
    // 原值优先去审批接口缓存的
    info.value.oldPrincipal = props.formValue.oldPrincipal || res.oldPrincipal
    info.value.oldInterest = props.formValue.oldInterest || res.oldInterest
    info.value.oldPenaltyInterest = props.formValue.oldPenaltyInterest || res.oldPenaltyInterest
    info.value.oldRepaymentDate = props.formValue.oldRepaymentDate || res.oldRepaymentDate
    formState.value = isEmpty(props.formValue) ? res : props.formValue
    loading.value = false
  } finally {
    loading.value = false
  }
}

// 是否展示此字段
function getIsShow(id: string) {
  if (props.allShow) return true
  return props.permissions && props.permissions[id]?.length
}

// 判断是否为只读
function getIsTxt(id: string) {
  // ['READ', 'WRITE', 'REQUIRED']
  if (props.permissions?.[id]) {
    if (
      props.permissions?.[id]?.includes('WRITE') ||
      props.permissions?.[id]?.includes('REQUIRED')
    ) {
      return false
    }
  }
  return true
}

onMounted(() => {
  getDetails()
})

async function handleSave() {
  try {
    const valid = await formRef.value.validate()
    if (valid) {
      let changeList: Recordable[] = []
      let data = unref(props.formValue) || {}
      for (let key in formState.value) {
        if (formState.value[key] !== data[key]) {
          changeList.push({
            fieldSerial: key,
            oldValue: data[key],
            newValue: formState.value[key]
          })
        }
      }
      return {
        changeList,
        data: Object.assign(cloneDeep(data), cloneDeep(formState.value))
      }
    }
  } catch (e) {
    return {
      errorMessage: '必填项未填写或填写错误'
    }
  }
}

function productTypeText(value: number) {
  return loanList.find(item => item.value === value)?.label || ''
}

function repaymentTypeText(value: number) {
  return repaymentTypes.find(item => item.value === value)?.label || ''
}

function rateListText(value: number) {
  return rateList.find(item => item.value === value)?.label || ''
}

defineExpose({
  handleSave
})
</script>
